const EXTENSIONS: Record<string, string> = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/webp": "webp",
  "image/gif": "gif",
};

/** A file name from a design's name and slide, e.g. "Spring listing promo - slide 2". */
export function designFileName(designName: string, position?: number): string {
  const base = designName.replace(/[\\/:*?"<>|]+/g, "").trim() || "design";
  return position != null ? `${base} - slide ${position}` : base;
}

/**
 * Saves an image to the viewer's device. A cross-origin image can only be named and saved after it's
 * fetched; when the fetch is refused, the image opens in a new tab so it can still be saved from there.
 */
export async function downloadImage(url: string, name: string): Promise<void> {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const extension = EXTENSIONS[blob.type] ?? "png";
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = `${name}.${extension}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, "_blank", "noopener");
  }
}
